/**
 * Application configuration
 *
 * Values are loaded from environment variables at build time.
 * For local development, create a .env.local file with these values.
 */

export const config = {
  // API
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000',

  // Cognito
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    redirectSignIn: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN || 'http://localhost:3000/callback',
    redirectSignOut: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT || 'http://localhost:3000',
  },

  // Feature flags
  features: {
    debugMode: import.meta.env.DEV,
  },
} as const

// Validate required config in production
if (import.meta.env.PROD) {
  const required = [
    'VITE_API_URL',
    'VITE_COGNITO_USER_POOL_ID',
    'VITE_COGNITO_CLIENT_ID',
    'VITE_COGNITO_DOMAIN',
  ]

  for (const key of required) {
    if (!import.meta.env[key]) {
      console.error(`Missing required environment variable: ${key}`)
    }
  }
}
